///////COMPONENTS///////
import { put, select, takeLatest } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import {
	globalLoadingActionCreators,
	errorManagerActionCreators,
	toastSuccessActionCreators,
	initKioskCreationBankDetailsActionCreators,
} from '../actions'
import * as R from '../../constants/Endpoint'
import { API_TOKEN } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'
import { uriList } from '../../routings/settings/RouteList'

const getKioskCreationBank = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_KIOSK_CREATION_BANK_DETAILS(payload.id)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(initKioskCreationBankDetailsActionCreators.getKioskCreationBankSuccess(data.data, payload.id))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(initKioskCreationBankDetailsActionCreators.getKioskCreationBankFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}
const putSaveBankDetails = function* ({ payload }) {
	const requestId = payload.requestId
	const user = yield select(selectIdsUser)

	const MsgParams = 'toast__initKiosk__kioskCreation_bankInformations_saved'
	const apiCall = R.PUT_SAVE_BANK_DETAILS(requestId)

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall, payload.data)

		yield put(initKioskCreationBankDetailsActionCreators.putSaveBankDetailsSuccess(data.data))

		yield put(toastSuccessActionCreators.hydrateToast(MsgParams))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(initKioskCreationBankDetailsActionCreators.putSaveBankDetailsFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}
const putContinueBankDetails = function* ({ payload }) {
	const requestId = payload.requestId
	const user = yield select(selectIdsUser)

	const MsgParams = 'toast__initKiosk__kioskCreation_bankInformations_entered'

	const redirectRequest =
		payload.redirectTest === 'customer'
			? `${uriList.initKiosks}${uriList.initKioskCustomerManager}${uriList.kioskAddItem}/${requestId}`
			: `${uriList.initKiosks}${uriList.initKioskBusinessManager}${uriList.kioskAddItem}/${requestId}`
	const apiCall = R.PUT_CONTINUE_BANK_DETAILS(requestId)

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall, payload.data)

		yield put(initKioskCreationBankDetailsActionCreators.putContinueBankDetailsSuccess(data.data))
		yield put(toastSuccessActionCreators.hydrateToast(MsgParams, redirectRequest))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(initKioskCreationBankDetailsActionCreators.putContinueBankDetailsFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.GET_KIOSK_CREATION_BANK_DETAILS, getKioskCreationBank)
	yield takeLatest(ActionsTypes.PUT_SAVE_BANK_DETAILS, putSaveBankDetails)
	yield takeLatest(ActionsTypes.PUT_CONTINUE_BANK_DETAILS, putContinueBankDetails)
}

export default sagas
